export default __webpack_public_path__ + "5857b513099633b221bc734dd4db5447.png";